import { produce } from 'immer'
import { BinRangeResponse } from 'src/models/binRange.models'
import {
  GET_COUNTRYS_FAILURE,
  GET_COUNTRYS_INIT,
  GET_COUNTRYS_SUCCESS,
  GetCountrysActions,
} from 'src/redux/actions/data/countrys.actions'
import {
  CLEAR_BIN_RANGE_INFO,
  ClearBinRangeInfoAction,
  GET_ISSUER_FROM_BIN_FAILURE,
  GET_ISSUER_FROM_BIN_INIT,
  GET_ISSUER_FROM_BIN_SUCCESS,
  GET_ISSUER_FROM_BIN_UNSUPPORTED_SUCCESS,
  GetIssuerFromBinActions,
  POST_CREDIT_CARD_FAILURE,
  POST_CREDIT_CARD_INIT,
  POST_CREDIT_CARD_SUCCESS,
  PostCreditCardActions,
} from 'src/redux/actions/data/creditCards.actions'
import {
  GET_ISSUERS_FAILURE,
  GET_ISSUERS_INIT,
  GET_ISSUERS_SUCCESS,
  GetIssuersActions,
} from 'src/redux/actions/data/issuerIntegrators.actions'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface RegisterAccountState {
  countrysFetched: boolean
  countrysFailed: boolean
  issuersFetched: boolean
  issuersFailed: boolean
  postingCreditCard: boolean
  fetchingIssuer: boolean
  binRangeInfo?: BinRangeResponse
  topLevelError?: string
  errorDetailMap?: ErrorDetailMap<string>
}

export const initialState: RegisterAccountState = {
  countrysFetched: false,
  countrysFailed: false,
  issuersFetched: false,
  issuersFailed: false,
  postingCreditCard: false,
  fetchingIssuer: false,
}

export type Actions =
  | GetCountrysActions
  | GetIssuersActions
  | PostCreditCardActions
  | GetIssuerFromBinActions
  | ClearBinRangeInfoAction

export const RegisterAccountReducer = (
  state = initialState,
  action: Actions,
): RegisterAccountState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_COUNTRYS_INIT: {
        return draft
      }
      case GET_COUNTRYS_SUCCESS: {
        draft.countrysFetched = true
        return draft
      }
      case GET_COUNTRYS_FAILURE: {
        draft.countrysFailed = true
        return draft
      }

      case GET_ISSUERS_INIT: {
        return draft
      }
      case GET_ISSUERS_SUCCESS: {
        draft.issuersFetched = true
        return draft
      }
      case GET_ISSUERS_FAILURE: {
        draft.issuersFailed = true
        return draft
      }

      case POST_CREDIT_CARD_INIT: {
        draft.postingCreditCard = true
        return draft
      }
      case POST_CREDIT_CARD_SUCCESS: {
        draft.postingCreditCard = false
        return draft
      }
      case POST_CREDIT_CARD_FAILURE: {
        draft.postingCreditCard = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        draft.errorDetailMap = errors.errorDetailMap
        return draft
      }
      case GET_ISSUER_FROM_BIN_INIT: {
        draft.fetchingIssuer = true
        draft.binRangeInfo = undefined
        draft.topLevelError = undefined
        draft.errorDetailMap = undefined
        return draft
      }
      case GET_ISSUER_FROM_BIN_SUCCESS: {
        draft.fetchingIssuer = false
        draft.binRangeInfo = action.payload.binRange
        draft.topLevelError = undefined
        draft.errorDetailMap = undefined
        return draft
      }
      case GET_ISSUER_FROM_BIN_UNSUPPORTED_SUCCESS: {
        draft.fetchingIssuer = false
        draft.binRangeInfo = action.payload.binRange
        draft.topLevelError = action.payload.error
        return draft
      }
      case GET_ISSUER_FROM_BIN_FAILURE: {
        draft.fetchingIssuer = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        draft.errorDetailMap = errors.errorDetailMap
        return draft
      }
      case CLEAR_BIN_RANGE_INFO: {
        draft.binRangeInfo = undefined
        draft.topLevelError = undefined
        draft.errorDetailMap = undefined
        return draft
      }
    }
  })
}

// This is not tied to any route props because the onboarding flow needs to attach to the regular register account flow

export default RegisterAccountReducer
